import { useCallback } from 'react';
import {
  sendChatJoinRoomEvent,
  sendChatLeaveRoomEvent,
  sendChatroomDeclineAccessEvent,
  sendChatroomGrantAccessEvent,
  sendChatroomRequestAccessEvent,
} from '@connect-x-app/hybrid-data-access';
import { ChatroomDeclineAccess, ChatroomGrantAccess, ChatroomRequestAccess } from '@connect-x-app/shared-domain-models';

export const useChatChatroomSocketSendEvents = () => {
  const sendRequestAccess = useCallback(async (payload: ChatroomRequestAccess) => {
    return await sendChatroomRequestAccessEvent(payload);
  }, []);

  const sendGrantAccess = useCallback(async (payload: ChatroomGrantAccess) => {
    return await sendChatroomGrantAccessEvent(payload);
  }, []);

  const sendDeclineAccess = useCallback(async (payload: ChatroomDeclineAccess) => {
    return await sendChatroomDeclineAccessEvent(payload);
  }, []);

  const sendChatJoinFlightRoom = useCallback(async (chatroomId: string) => {
    return await sendChatJoinRoomEvent(chatroomId);
  }, []);

  const sendChatLeaveFlightRoom = useCallback(async (chatroomId: string) => {
    return await sendChatLeaveRoomEvent(chatroomId);
  }, []);

  return { sendChatJoinFlightRoom, sendChatLeaveFlightRoom, sendDeclineAccess, sendGrantAccess, sendRequestAccess };
};
